import type { LayerTrackingName } from '$lib/services/tracking/googleAnalytics/events';

export type LayerName = 'michelin' | 'historic' | 'hybrid' | 'scenic';

export const layerTrackingNames: Record<LayerName, LayerTrackingName> = {
	michelin: 'michelin',
	historic: 'historical',
	hybrid: 'hybrid',
	scenic: 'scenic',
};
